import React from "react";

const TrackReplaySVGTrack = ({
  timelineInitialDate,
  timelineEndDate,
  timeLineTrack,
  widthAux,
  handleMouseEnterTrackSvg,
  handleMouseLeaveTrackSvg,
  transformTimelineData,
  newPositionY,
  nameReplay,
  colorReplay
}) => {
  if (!Array.isArray(timeLineTrack) || timeLineTrack.length === 0) {
    return null;
  }
  return (
    <>
    <g>
        <rect text x="2" y={newPositionY - 22} fill={colorReplay} width={43} height={18} rx={6} ry={6}/>
        <text x={ 11/2} y={(newPositionY - 22) + 26/2}  fontSize={12} fill="white">
        {nameReplay}
      </text>
    </g>
      
      {timeLineTrack.map((item, index) => {
        var dataPosition = transformTimelineData(
          9,
          widthAux,
          timelineInitialDate,
          timelineEndDate,
          item.intial_datetimeUnix,
          item.end_datetimeUnix
        );
        return (
          <rect
            x={dataPosition.pixelPosition}
            y={newPositionY}
            width={dataPosition.statusWidth}
            height="25"
            rx="2"
            ry="2"
            fill={item.colour}
            onMouseEnter={(e) => handleMouseEnterTrackSvg(e, item)}
            onMouseLeave={handleMouseLeaveTrackSvg}
          />
        );
      })}
    </>
  );
};

export default TrackReplaySVGTrack;
